export default __webpack_public_path__ + "static/media/mockupRastreador.670657b1.png";